import { axios_instance } from "./api";

export type ChatHistoryType =
  | "zalo-web"
  | "zalo-app"
  | "telegram-web"
  | "telegram-app"
  | "what-web"
  | "what-app"
  | "viber-app"
  | "teams-web"
  | "teams-app";

export interface ChatHistoryItem {
  id: string;
  agent_id: string;
  type: ChatHistoryType;
  path: string;
  created: number;
  modified: number;
}

export interface ChatHistoryResponse {
  data: ChatHistoryItem[];
  message: string;
  total_filter: number;
}

export interface ChatHistoryParams {
  agent_id?: string;
  type?: ChatHistoryType | (() => ChatHistoryType);
  page: number;
  size: number;
}

export const getChatHistory = async (
  params: ChatHistoryParams,
): Promise<ChatHistoryResponse> => {
  const paramsWithDefaults = {
    agent_id: params.agent_id,
    type: params.type,
    page: params.page,
    size: params.size,
  };
  const response = await axios_instance.post<ChatHistoryResponse>(
    "/api/v1/view/chat/",
    paramsWithDefaults,
  );
  return response.data;
};
